import { faAngleRight } from '@fortawesome/pro-regular-svg-icons'
import { Button } from '@karnov/kui-react'
import { motion } from 'motion/react'
import { type FC } from 'react'

import { CompanyUploadHeader } from 'components/CompanyUploadHeader'
import { KarnovDocumentHeader } from 'components/KarnovDocumentHeader'
import { MessageReference } from 'types/Api'

type Props = {
  isExpanded: boolean
  reference: MessageReference
}

export const ReferenceHeader: FC<Props> = ({ isExpanded, reference }) => (
  <div className="group flex w-full gap-x-2">
    <div className="mt-0.75 flex flex-grow">
      {reference.sourceType === 'karnov_document' && (
        <KarnovDocumentHeader reference={reference} />
      )}
      {reference.sourceType === 'company_upload' && (
        <CompanyUploadHeader reference={reference} />
      )}
    </div>
    <div className="flex h-fit items-center justify-center self-center rounded-lg group-hover:bg-karnovnote-secondary print:hidden">
      <motion.div
        animate={{ rotate: isExpanded ? 90 : 0 }}
        transition={{ duration: 0.2, ease: 'easeInOut' }}
      >
        <Button
          icon={faAngleRight}
          isSmall
          variant="plain"
          isOnKarnovNote
        />
      </motion.div>
    </div>
  </div>
)
